import { Helmet } from 'react-helmet-async';

interface SeoHeadProps {
    title: string;
    description: string;
    image?: string;
    type?: 'website' | 'article';
}

const SITE_NAME = 'Profestival.cz';
const DEFAULT_IMAGE = '/og-image.png';

const SeoHead = ({ title, description, image, type = 'website' }: SeoHeadProps) => {
    const fullTitle = `${title} | ${SITE_NAME}`;
    const metaImage = image || DEFAULT_IMAGE;
    // Ensure image is absolute URL if it doesn't start with http
    const absoluteImage = metaImage.startsWith('http')
        ? metaImage
        : `https://profestival.cz${metaImage}`;

    return (
        <Helmet>
            {/* Basic metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={absoluteImage} />
            <meta property="og:site_name" content={SITE_NAME} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absoluteImage} />
        </Helmet>
    );
};

export default SeoHead;
